import './Loader.scss';

export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </div>
  );
};
